import {ToggleButtonGroup} from '@wandb/components';
import React from 'react';
import {useNumberFormatter} from 'react-aria';

import {PatchDelta} from '../PatchDelta';
import type {RenderMode} from './types';
import type {PatchStats} from './usePatchStats';

const VIEW_MODES = [
  {
    id: 'inline',
    children: 'Unified',
  },
  {
    id: 'side-by-side',
    children: 'Split',
  },
];

type PatchSummaryProps = {
  isSmallScreen: boolean;
  onSetRenderMode: (mode: RenderMode) => void;
  renderMode: RenderMode;
  stats: PatchStats;
};

export function PatchSummary({
  isSmallScreen,
  onSetRenderMode,
  renderMode,
  stats,
}: PatchSummaryProps) {
  const formatter = useNumberFormatter();
  return (
    <div className="flex flex-row items-center justify-between gap-16 mb-16">
      <div className="flex flex-row items-center gap-4">
        <div className="mr-4">
          {formatter.format(stats.perPatch.length)} files changed
        </div>
        <PatchDelta adds={stats.adds} dels={stats.dels} />
      </div>
      {!isSmallScreen ? (
        <ToggleButtonGroup
          aria-label="Patch view mode"
          items={VIEW_MODES}
          selectedKeys={[renderMode]}
          onSelectionChange={keys => {
            const newValue = [...keys][0] as
              | 'side-by-side'
              | 'inline'
              | undefined;
            if (newValue) {
              onSetRenderMode(newValue);
            }
          }}
        />
      ) : null}
    </div>
  );
}
